export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "futurebet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "futurebet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
